export const CUSTOS_COL_ESCOPO = "Escopo Macro da Obra";
export const CUSTOS_COL_MATERIAL = "Material (R$)";
export const CUSTOS_COL_SERVICOS = "Serviços (R$)";
export const CUSTOS_COL_TOTAL = "Total (R$)";
export const CUSTOS_DOMINANTE = "Obra dominante";
export const CUSTOS_SEM_ESCOPO = "Nenhum escopo macro vinculado a este tipo.";
export const CUSTOS_TOTAL_MACRO = "Total Escopo Macro";
export const CUSTOS_TOTAL_FACILIDADES = "Total Facilidades";
export const CUSTOS_TOTAL_OBRA = "Total Obra";
